import jQuery from 'jquery';
import {findInContext, isDescendant} from "../util/jquery-ext";
import {ToggleItem, defaultOptions as toggleItemDefaultOptions} from "./toggle-item";

const GROUP_CLASS = "toggle-group";

export const ToggleGroup = {
  options: {
    ...toggleItemDefaultOptions,
    scope: "item", // default scope of the button and content selectors of each item in "items"
    exclusive: true // allow only one item to be active
  },

  _create: function () {
    this.element.addClass(GROUP_CLASS);

    if (typeof(this.options.items) === "string") {
      let itemOptionsStub = {};
      itemOptionsStub[this.options.items] = {}; // use default options
      this.options.items = itemOptionsStub;
    }

    this.items = jQuery();
    for (let itemSelector in this.options.items) {
      this.element.find(itemSelector).each((_, item) => {
        item = jQuery(item);
        this.items = this.items.add(item.toggleItem({
          ...this.options,
          ...this.options.items[itemSelector],
          button: this._getItemComponent(item, itemSelector, "button"),
          selectButton: this._getItemComponent(item, itemSelector, "selectButton"),
          hover: this._getItemComponent(item, itemSelector, "hover"),
          touchHover: this._getItemComponent(item, itemSelector, "touchHover"),
          content: this._getItemComponent(item, itemSelector, "content"),
          beforeActivate: (e) => {
            if (this.options.exclusive) {
              this.deactivateAll(e);
            }
          }
        }));
      });
    };
  },

  _getItemOption: function (itemKey, optionKey) {
    if (this.options.items[itemKey]
      && typeof(this.options.items[itemKey][optionKey]) !== "undefined"
    ) {
      return this.options.items[itemKey][optionKey];
    }
    else {
      return this.options[optionKey];
    }
  },

  _getItemComponent: function(item, itemKey, componentKey) {
    const scope = this._getItemOption(itemKey, "scope");
    const componentSelector = this._getItemOption(itemKey, componentKey);
    if (componentSelector instanceof jQuery) {
      return componentSelector;
    }

    switch (scope) {
      case "body":
        return jQuery(componentSelector); // search anywhere
      case "group":
        return this.element.find(componentSelector); // search inside group
      case "before-item":
        return item.prev(componentSelector); // search previous sibling of item
      case "after-item":
        return item.next(componentSelector); // search next sibling of item
      case "item":
      default:
        return findInContext(item, componentSelector); // search inside item
    }
  },

  deactivateAll: function (event) {
    this.items.toggleItem("deactivate", event);
  },

  getActiveItems: function () {
    return this.items.filter((_, item) => jQuery(item).toggleItem('isActive'));
  }

};